import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { cashDefaults, cashReport, type CashInputs } from "@/lib/tools/calc";
import { NumberField, ToolPageShell, toolHead } from "@/components/site/tools/ToolPageShell";
import { CashChart } from "@/components/site/tools/ToolCharts";

export const Route = createFileRoute("/tools/cash-runway-calculator")({
  head: () => toolHead("cash-runway-calculator"),
  component: CashRunwayPage,
});

function CashRunwayPage() {
  const [i, setI] = useState<CashInputs>(cashDefaults);
  const set = (k: keyof CashInputs) => (v: number | null) =>
    setI((p) => ({ ...p, [k]: k === "oneOffWeek" ? Math.min(13, Math.max(1, Math.round(v ?? 1))) : (v ?? 0) }));
  return (
    <ToolPageShell
      slug="cash-runway-calculator"
      report={cashReport(i)}
      inputs={i}
      chart={<CashChart inputs={i} />}
      form={
        <div className="grid gap-4 sm:grid-cols-2">
          <NumberField id="cr-cash" label="Cash in bank today" prefix="$" value={i.cash} onChange={set("cash")} />
          <NumberField id="cr-floor" label="Minimum cash you are comfortable holding" prefix="$" value={i.floor} onChange={set("floor")} min={0} />
          <NumberField id="cr-in" label="Cash in per month" prefix="$" value={i.monthlyIn} onChange={set("monthlyIn")} min={0} hint="Collections, not sales." />
          <NumberField id="cr-out" label="Cash out per month" prefix="$" value={i.monthlyOut} onChange={set("monthlyOut")} min={0} hint="Wages, suppliers, rent, tax and loan repayments." />
          <NumberField id="cr-oneoff" label="One off payment coming" prefix="$" value={i.oneOff} onChange={set("oneOff")} min={0} hint="For example a BAS, insurance or equipment payment." />
          <NumberField id="cr-week" label="Week it falls in (1 to 13)" value={i.oneOffWeek} onChange={set("oneOffWeek")} min={1} max={13} step={1} />
        </div>
      }
    />
  );
}
